import { AbstractEntityTabLoader } from '../../utils/component/abstract-entity-tab-loader/abstract-entity-tab.loader';
import { LearningSectionEntity } from '../learning-section-entity';

export class LearningSectionTabLoader
  extends AbstractEntityTabLoader<LearningSectionEntity> {
  protected pageSize = 20;
  protected sort = 'name';
  protected searchFilterKey = 'filter[nameLike]';
}
